import { render } from "./MNavBar.vue?vue&type=template&id=00d8fe6a&scoped=true&ts=true"
import script from "./MNavBar.vue?vue&type=script&lang=ts"
export * from "./MNavBar.vue?vue&type=script&lang=ts"

import "./MNavBar.vue?vue&type=style&index=0&id=00d8fe6a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d8fe6a"]])

export default __exports__